// extracted by mini-css-extract-plugin
export default {"noMarginTop":"_24Jx3"};